/** Nivel 1: configuración (privada/pública). Nivel 2: tipo de mensaje. Nivel 3: tipo de tarea. */
export const MAILING_REPORT_LEVEL_CONFIGURATION = 1;
export const MAILING_REPORT_LEVEL_MESSAGE_TYPE = 2;
export const MAILING_REPORT_LEVEL_TASK_MESSAGE_TYPE = 3;

export interface MailingReportNodeDTO {
    key: string;
    level: number;
    privateConfiguration: boolean | null;
    messageTypeId: number | null;
    taskMessageTypeId: number | null;
    /** Vacía en el nivel 1: la descripción sale de privateConfiguration. */
    description: string | null;
    countCreated: number;
    countSent: number;
    countCancelled: number;
    children: MailingReportNodeDTO[];
}

/** Rango de fechas en formato ISO (YYYY-MM-DD). */
export interface MailingReportDateRange {
    initialDate: string;
    finalDate: string;
}

/** Estados de un mensaje en messagesender (id + descripción, igual que messagestatemsi18n). */
export const MAILING_REPORT_MESSAGE_STATES: { id: number; description: string }[] = [
    { id: 1, description: 'Creado' },
    { id: 2, description: 'Enviado' },
    { id: 3, description: 'Recibido' },
    { id: 4, description: 'Abierto' },
    { id: 9, description: 'Leído' },
    { id: 5, description: 'Error' },
    { id: 6, description: 'Cancelado' },
    { id: 7, description: 'Desactivado' },
    { id: 8, description: 'Reactivado' },
];

/** Nodo del árbol sobre el que se pide el detalle, más los filtros. */
export interface MailingReportDetailFilter extends MailingReportDateRange {
    privateConfiguration?: boolean;
    messageTypeId?: number;
    taskMessageTypeId?: number;
    messageStateId?: number;
    from?: string;
    to?: string;
}

export interface MailingReportDetailItemDTO {
    messageId: number;
    messageTypeDescription: string | null;
    taskMessageTypeDescription: string | null;
    subject: string | null;
    from: string | null;
    to: string | null;
    messageStateDescription: string | null;
    /** Epoch en milisegundos. */
    dateChanged: number | null;
    dateToSend: number | null;
}

export interface MailingReportDetailPageDTO {
    items: MailingReportDetailItemDTO[];
    count: number;
}

export interface MailingReportMessageStateDTO {
    state: string | null;
    dateChanged: number | null;
    /** Puede traer HTML. */
    description: string | null;
}
